import { DrawerBody } from '@chakra-ui/react';
import React from 'react';

import { FinleyAi as FinleyAiTypes } from '@finley-technologies/finley-types';

import { FinleyAiThreads } from './FinleyAiThreads';
import { AthenaSqlGenerationViewContext } from './types';

type FinleyAiAthenaSqlGenerationDrawerHistoryViewProps = {
  viewContext: AthenaSqlGenerationViewContext;
  userId: string;
  handleFinleyAiThreadSelection: (thread: FinleyAiTypes.FinleyAiThread) => void;
};
export const FinleyAiAthenaSqlGenerationDrawerHistoryView = ({
  viewContext,
  userId,
  handleFinleyAiThreadSelection,
}: FinleyAiAthenaSqlGenerationDrawerHistoryViewProps) => {
  return (
    <DrawerBody>
      <FinleyAiThreads
        userId={userId}
        handleFinleyAiThreadSelection={handleFinleyAiThreadSelection}
        finleyAiThreadId={viewContext.finleyAiThreadId}
      />
    </DrawerBody>
  );
};
